<div class="overview-tiles">
  <div class="title-container" *ngIf="showTitle">
  <span class="section-title">Overview</span>
  <app-ask-polaris-button *ngIf="showAskPolaris" [widget]="DashboardWidget.MY_COMPETITION_OVERVIEW"></app-ask-polaris-button>
  </div>
  <div [class.cards-wrapper]="true" [class.no-data]="!cards.length" [ngClass]="direction" >
    <ng-container *ngFor="let card of cards">
      <app-overview-card
        *ngIf="card.type === 'multiple'"
        [type]="card.type"
        [metrics]="card.metrics"
        [cardWidth]="getCardWidth()"
        [loading]="loading">
      </app-overview-card>
      <app-overview-card
        *ngIf="card.type === 'single'"
        [type]="card.type"
        [iconPath]="card.iconPath"
        [title]="card.title"
        [value]="card.value"
        [valueType]="card.valueType"
        [valueDescription]="card.valueDescription"
        [trend]="card.trend"
        [cardWidth]="getCardWidth()"
        [tooltip]="card.tooltip"
        [loading]="loading"
        [cardHeight]="direction === 'vertical' ? '107px' : 'auto'"
        [titleTooltip]="card.titleTooltip">
      </app-overview-card>
    </ng-container>
  </div>
</div>
